import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, changeItemsValue, getListItems } from '../../public/utility'
class ExpenseTypeSelect extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    handlerSave = () => {
        const { onClose } = this.props
        const { changedValues基本信息, initValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        onClose && onClose()
        location.hash = `/QYWX/ExpenseApply/0/${encodeURIComponent(values.报支类别)}`
        //console.log('changedValues基本信息.报支类别',changedValues基本信息.报支类别)
        //Tyan.pubForm.showDialog('',props => <ExpenseApply {...props} id={-1} expenseName={changedValues基本信息.报支类别} />)
        //showDetail(props => <ExpenseApply {...props} id={data.id} expenseName={changedValues基本信息.报支类别} onClose={onClose} />)
    }

    // handlerClose = () => {
    //     if (!this.bChanged()) {
    //         window.history.back()
    //         return
    //     }
    //     Tyan.pubForm.showConfirm('确定要放弃更改吗？', () => window.history.back())
    // }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    canSave = () => {
        return getFormValue(this, '基本信息', '报支类别')
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        return [
            { _radio: '', name: '报支类别', itemMinWidth: 125, minWidth: '95%', items: [/* '采购报支单', */ '一般报支单', '福利金报支单', '出差/外训报支单', '交际费报支单', '委外测试费报支单'], required: true }
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { errorMessage, bReadOnly } = this.state
        if (errorMessage) return <Message text={errorMessage} />
        const canSave = this.canSave()
        const bChanged = this.bChanged()
        return <Body data={this} maxWidth="700"
            controls={
                bReadOnly ?
                    [
                        { _button: bChanged && '取消' || '关闭', icon: '', handler: this.handlerClose },
                    ] : [
                        { _button: '确定', icon: '', handler: this.handlerSave, disabled: !(canSave && bChanged) },
                        { _button: bChanged ? '取消' : '关闭', icon: '', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default connect()(ExpenseTypeSelect)